import { gql } from '@apollo/client';

// ATS Status
export const GET_ATS_STATUS = gql`
  query GetAshbyStatus {
    getAshbyStatus {
      atsType
      enabled
      connectedAt
    }
  }
`;

// ATS Connection
export const CONNECT_ATS = gql`
  mutation ConnectAshby($apiKey: String!) {
    connectAshby(apiKey: $apiKey) {
      atsType
      enabled
      connectedAt
    }
  }
`;

export const DISCONNECT_ATS = gql`
  mutation DisconnectAshby {
    disconnectAshby
  }
`;

// ATS Jobs
export const LIST_ATS_JOBS = gql`
  query ListAshbyJobs {
    listAshbyJobs {
      id
      title
      status
      departmentName
      locationName
      linkedCavalryJobId
    }
  }
`;

export const LINK_ATS_JOB = gql`
  mutation LinkAshbyJob($ashbyJobId: String!, $cavalryJobId: String!, $mode: String, $targetStageId: String, $sourceStageId: String) {
    linkAshbyJob(ashbyJobId: $ashbyJobId, cavalryJobId: $cavalryJobId, mode: $mode, targetStageId: $targetStageId, sourceStageId: $sourceStageId)
  }
`;

export const LIST_ATS_INTERVIEW_STAGES = gql`
  query ListAshbyInterviewStages($ashbyJobId: String!) {
    listAshbyInterviewStages(ashbyJobId: $ashbyJobId) {
      id
      name
      orderInInterviewPlan
      type
    }
  }
`;

export const UNLINK_ATS_JOB = gql`
  mutation UnlinkAshbyJob($cavalryJobId: String!) {
    unlinkAshbyJob(cavalryJobId: $cavalryJobId)
  }
`;

// ATS Candidates
export const LIST_ATS_CANDIDATES = gql`
  query ListAshbyCandidates($jobId: String!) {
    listAshbyCandidates(jobId: $jobId) {
      id
      name
      email
      applicationId
      jobId
      jobTitle
      currentStage
    }
  }
`;

export const BULK_IMPORT_ATS_CANDIDATES = gql`
  mutation BulkImportAshbyCandidates($candidates: [AshbyCandidateInput!]!, $cavalryJobId: String!) {
    bulkImportAshbyCandidates(candidates: $candidates, cavalryJobId: $cavalryJobId)
  }
`;

export const LIST_ATS_IMPORTS = gql`
  query ListAtsImports($cavalryJobId: String!) {
    listAtsImports(cavalryJobId: $cavalryJobId) {
      _id
      atsType
      atsCandidateId
      atsApplicationId
      candidateEmail
      candidateName
      status
      applicationId
      syncedAt
      createdAt
    }
  }
`;

export const DELETE_ATS_IMPORTED_CANDIDATE = gql`
  mutation DeleteAshbyImportedCandidate($importId: String!) {
    deleteAshbyImportedCandidate(importId: $importId)
  }
`;

export const GET_ATS_BATCH_STATUS = gql`
  query GetAtsBatchStatus($batchId: String!) {
    getAtsBatchStatus(batchId: $batchId) {
      total
      completed
      failed
      status
      errors
    }
  }
`;

// ==========================================
// Greenhouse-specific queries and mutations
// ==========================================

// Greenhouse OAuth
export const GET_GREENHOUSE_OAUTH_URL = gql`
  query GetGreenhouseOAuthUrl {
    getGreenhouseOAuthUrl {
      url
      state
    }
  }
`;

// Greenhouse Status
export const GET_GREENHOUSE_STATUS = gql`
  query GetGreenhouseStatus {
    getGreenhouseStatus {
      atsType
      enabled
      connectedAt
    }
  }
`;

// Greenhouse Disconnect
export const DISCONNECT_GREENHOUSE = gql`
  mutation DisconnectGreenhouse {
    disconnectGreenhouse
  }
`;

// Greenhouse Jobs
export const LIST_GREENHOUSE_JOBS = gql`
  query ListGreenhouseJobs {
    listGreenhouseJobs {
      id
      title
      status
      departmentName
      officeName
      linkedCavalryJobId
    }
  }
`;

// Greenhouse Job Linking
export const LINK_GREENHOUSE_JOB = gql`
  mutation LinkGreenhouseJob($greenhouseJobId: String!, $cavalryJobId: String!, $mode: String, $targetStageId: String, $sourceStageId: String) {
    linkGreenhouseJob(greenhouseJobId: $greenhouseJobId, cavalryJobId: $cavalryJobId, mode: $mode, targetStageId: $targetStageId, sourceStageId: $sourceStageId)
  }
`;

export const UNLINK_GREENHOUSE_JOB = gql`
  mutation UnlinkGreenhouseJob($cavalryJobId: String!) {
    unlinkGreenhouseJob(cavalryJobId: $cavalryJobId)
  }
`;

// Greenhouse Interview Stages
export const LIST_GREENHOUSE_INTERVIEW_STAGES = gql`
  query ListGreenhouseInterviewStages($greenhouseJobId: String!) {
    listGreenhouseInterviewStages(greenhouseJobId: $greenhouseJobId) {
      id
      name
      priority
    }
  }
`;

// Greenhouse Candidates
export const LIST_GREENHOUSE_CANDIDATES = gql`
  query ListGreenhouseCandidates($jobId: String!) {
    listGreenhouseCandidates(jobId: $jobId) {
      id
      name
      email
      applicationId
      jobId
      jobTitle
      currentStage
    }
  }
`;

// Greenhouse Bulk Import
export const BULK_IMPORT_GREENHOUSE_CANDIDATES = gql`
  mutation BulkImportGreenhouseCandidates($candidates: [GreenhouseCandidateInput!]!, $cavalryJobId: String!) {
    bulkImportGreenhouseCandidates(candidates: $candidates, cavalryJobId: $cavalryJobId)
  }
`;

// Greenhouse Delete Import
export const DELETE_GREENHOUSE_IMPORTED_CANDIDATE = gql`
  mutation DeleteGreenhouseImportedCandidate($importId: String!) {
    deleteGreenhouseImportedCandidate(importId: $importId)
  }
`;

// Greenhouse Assessment API Key
export const GENERATE_GREENHOUSE_ASSESSMENT_API_KEY = gql`
  mutation GenerateGreenhouseAssessmentApiKey {
    generateGreenhouseAssessmentApiKey
  }
`;

export const GET_GREENHOUSE_ASSESSMENT_API_KEY = gql`
  query GetGreenhouseAssessmentApiKey {
    getGreenhouseAssessmentApiKey
  }
`;

// Ashby Assessment API Key
export const GENERATE_ASHBY_ASSESSMENT_API_KEY = gql`
  mutation GenerateAshbyAssessmentApiKey {
    generateAshbyAssessmentApiKey
  }
`;

export const GET_ASHBY_ASSESSMENT_API_KEY = gql`
  query GetAshbyAssessmentApiKey {
    getAshbyAssessmentApiKey
  }
`;
